import { stateNameToCode } from "./state";

export function combineStreetAddress(addressLines: string[]): string {
  return addressLines.join(" ");
}

export type AddressParts = {
  addressStreet?: string;
  city?: string;
  stateCode?: string;
  zip?: string;
};

/**
 * Format a property address for display.
 * @example "123 Main St, Apt 1, Anytown, CA 12345"
 * @param propertyAddress The property address to format.
 * @returns The formatted property address.
 */
export function formatAddress({ addressStreet, city, stateCode, zip }: AddressParts) {
  const parts = [addressStreet, city, stateNameToCode(stateCode)];
  return `${parts
    .map((p) => p?.trim())
    .filter((p) => !!p)
    .join(", ")}${zip ? ` ${zip}` : ""}`;
}

export function formatAddressForInvoicePdf({ addressStreet, city, stateCode, zip }: AddressParts) {
  return `${addressStreet}\n${city}, ${stateNameToCode(stateCode)} ${zip}`;
}
